import { isArray } from '../common/util';
import { DEFAULT_MESSSAGE } from '../model/common';
import { FormCustomValidation } from './custom_validation';
export var composeValidator = function (rule, msg, arg) { return function (val) {
    if (!rule(val)) {
        return msg
            .replace('{min}', arg || '')
            .replace('{max}', arg || '')
            .replace('{pattern}', arg || '')
            .replace('{length}', '' + valueLength(val));
    }
}; };
// Rules
export var valueLength = function (val) {
    if (typeof val === 'boolean') {
        return val ? 1 : 0;
    }
    else if (val && isArray(val)) {
        return val.length;
    }
    else if (typeof val === 'number') {
        return val.toString().length;
    }
    else {
        return val ? val.toString().trim().length : 0;
    }
};
var validateRequired = function (val) { return valueLength(val) > 0; };
var validateInt = function (val) { return Number.isInteger(Number(val)); };
var validateMinLength = function (min) { return function (val) { return valueLength(val) >= min; }; };
var validateMaxLength = function (max) { return function (val) { return valueLength(val) <= max; }; };
var validatePattern = function (pattern) { return function (val) {
    return new RegExp(pattern).test(val.toString());
}; };
export var customValidator = function (validatorName, arg, element) { return function (val) {
    var funcName = FormCustomValidation.prototype.getFunction(validatorName);
    if (funcName) {
        var validatorResult = funcName(val, arg, element);
        if (!validatorResult.value) {
            return validatorResult.message ? validatorResult.message : DEFAULT_MESSSAGE.messageGeneric;
        }
    }
}; };
// Validators from Functions
export var isRequired = function (message) {
    if (message === void 0) { message = ''; }
    return composeValidator(validateRequired, message);
};
export var isInt = function (msg) {
    if (msg === void 0) { msg = ''; }
    return composeValidator(validateInt, msg);
};
export var isMinLength = function (min, msg) { return composeValidator(validateMinLength(min), msg || '', min); };
export var isMaxLength = function (max, msg) { return composeValidator(validateMaxLength(max), msg || '', max); };
export var isPattern = function (pattern, msg) {
    return composeValidator(validatePattern(pattern), msg || '', pattern);
};
export var isCustomValidator = function (validatorName, arg, element) {
    return customValidator(validatorName, arg, element);
};
var Validation = /** @class */ (function () {
    function Validation(schema) {
        var _this = this;
        this.validate = function (inputs) {
            return Object.keys(_this.schema).reduce(function (errors, key) {
                var errorMessage;
                var validators = _this.schema[key];
                var value = inputs[key];
                for (var _i = 0, _a = Object.keys(validators); _i < _a.length; _i++) {
                    var i = _a[_i];
                    var validator = validators[i];
                    if (typeof validator === 'function') {
                        var res = validator(value);
                        if (res) {
                            errorMessage = res;
                            break;
                        }
                    }
                    else {
                        console.log('dispatch consumer function for ', validator);
                        break;
                    }
                }
                if (errorMessage) {
                    errors[key] = errorMessage;
                }
                return errors;
            }, {});
        };
        this.schema = schema;
    }
    return Validation;
}());
export { Validation };
//# sourceMappingURL=validation.js.map